import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";

import {
  Page,
  TopTags,
  BottomTags,
  BottomTagHtml,
  LayoutContainer,
  Content,
  MiddleContent,
} from "./Layout.styles";

const Layout = () => {
  return (
    <LayoutContainer>
      <Sidebar />
      <Content>
        <Page>
          <TopTags>&lt;body&gt;</TopTags>
          <MiddleContent>
            <Outlet />
          </MiddleContent>

          <BottomTags>&lt;/body&gt;</BottomTags>
        </Page>
      </Content>
    </LayoutContainer>
  );
};

export default Layout;
